import React, { FunctionComponent, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import CartInput from "@Components/atoms/cart/CartInput";
import CartCheckboxWithLabel from "@Components/molecules/cart/CheckboxWithLabel";
import { ReactComponent as IconHelp } from "@Icons/help-circle.svg";
import useCartContext from "../../../../hooks/useCartContext";
import cvv from "./images/cvc.svg";
import "./style.scss";

interface Props {
  onSaveCreditCard: () => void;
  saveCreditCard: boolean;
}

const CartPaymentForm: FunctionComponent<Props> = ({ onSaveCreditCard, saveCreditCard }) => {
  const intl = useIntl();
  const [processOutLoaded, setProcessOutLoaded] = useState<boolean>(false);
  const { configuration } = useCartContext();

  useEffect(() => {
    if (!processOutLoaded && configuration.paymentProvider) {
      setProcessOutLoaded(configuration.paymentProvider.loadProcessOutModal());
    }
  });

  return (
    <form action="" method="POST" className="CartPaymentForm" id="PaymentForm">
      <div className="CartInput">
        <div
          className="CartInput-input"
          data-processout-input="cc-number"
          data-processout-placeholder="0000 0000 0000 0000"
          id="cc-number"
        />
        <label htmlFor="cc-number" className="CartInput-label">
          {intl.formatMessage({
            id: "cheerz_CartPaymentForm_cb_number_placeholder",
          })}
        </label>
      </div>
      <div className="CartPaymentForm-line">
        <div className="CartInput">
          <div
            className="CartInput-input"
            data-processout-input="cc-exp-month"
            data-processout-placeholder="00"
          />
          <label htmlFor="cc-exp-month" className="CartInput-label">
            {intl.formatMessage({
              id: "cheerz_CartPaymentForm_cb_month_placeholder",
            })}
          </label>
        </div>
        <div className="CartInput">
          <div
            className="CartInput-input"
            data-processout-input="cc-exp-year"
            data-processout-placeholder="00"
          />
          <label htmlFor="cc-exp-year" className="CartInput-label">
            {intl.formatMessage({
              id: "cheerz_CartPaymentForm_cb_year_placeholder",
            })}
          </label>
        </div>
        <div className="CartInput">
          <div
            className="CartInput-input CartPaymentForm-cvv"
            data-processout-input="cc-cvc"
            data-processout-placeholder="000"
          >
            <IconHelp />
            <img className="CartPaymentForm-cvv-image" src={cvv} alt="" />
          </div>
          <label htmlFor="cc-cvc" className="CartInput-label">
            {intl.formatMessage({
              id: "cheerz_CartPaymentForm_cb_cvv_placeholder",
            })}
          </label>
        </div>
      </div>
      <div className="CartPaymentForm-line" data-processout-input="cardholdername">
        <CartInput
          placeholder={intl.formatMessage({
            id: "cheerz_CartPaymentForm_cb_cart_name_placeholder",
          })}
          name="cardholdername"
        />
      </div>
      <CartCheckboxWithLabel checked={saveCreditCard} onChange={onSaveCreditCard}>
        {intl.formatMessage({ id: "cheerz_CartPaymentForm_cb_save_card" })}
      </CartCheckboxWithLabel>
    </form>
  );
};

export default CartPaymentForm;
